const template = document.createElement('template');
template.innerHTML = `
<style>
  :host {
    position: relative;
    width: 89vw;
    height: auto;
    margin: 0.625rem 0.625rem 2.93rem 0.625rem;
  }

  .bottle-image__wrapper {
    position: relative;
    color: #24495D;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2.5rem;
    max-width: 20rem;
  }

  .bottle-image {
    position: relative;
    padding-bottom: 109.1%;
    overflow: hidden;
  }

  .bottle-image img {
    width: auto;
    height: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    object-position: center;
    object-fit: contain;
  }

  .bottle-text {
    position: absolute;
    left: 50%;
    width: 26.2vw;
    transform: translate(-50%, -50%);
    display: flex;
    flex-flow: column;
    line-height: 90%;
    text-align: center;
    justify-content: center;
    z-index: 1;
    text-transform: capitalize;
    font-size: 0.5625rem;
    min-height: 1.625rem;
    bottom: 23.8%;
  }

  [data-image-active="Bottle"] .bottle-text  {
    transform: translate(calc(-50% + 0.625rem), -50%) rotate(5deg);
    font-family: var(--font-primary);
  }

  [data-font-type="Modern"] .bottle-text {
    font-family: var(--font-secondary);
  }

  [data-image-active="Box"] .bottle-text {
    bottom: 35%;
    width: 27vw;
  }

  .bottle-message {
    overflow: hidden;
    word-break: break-all;
  }

  .bottle-name {
    font-size: 0.5rem;
    letter-spacing: 0.19vw;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden; 
    padding: 0.25rem 0;
  }

  [data-font-type="Modern"] .bottle-name {
    font-weight: 500;
  }

  @media screen and (min-width: 576px) {
    .bottle-image__wrapper {
      max-width: 30rem;
    }

    .bottle-text {
      min-height: 2.5rem;
      font-size: 0.75rem;
      bottom: 23.3%;
    }
  }
  
  @media screen and (min-width: 767px) {
    :host {
      width: 80vw;
    }

    [data-image-active="Box"] .bottle-text {
      bottom: 35.6%;
      width: 24vw;
    }

    .bottle-image__wrapper {
      max-width: 40rem;
    }

    .bottle-text {
      min-height: 3.75rem;
      font-size: 1rem;
      bottom: 22.3%;
    }
  }

  @media screen and (min-width: 991px) {
    :host {
      width: 47.1875rem;
      margin-top: auto;
      margin-bottom: auto;
      padding: 1.5rem;
    }

    .bottle-name {
      font-size: 0.6875rem;
      letter-spacing: 0.0938rem;
    }

    [data-image-active="Box"] .bottle-text {
      width: 9.375rem;
      bottom: 36.5%;
    }

    .bottle-image__wrapper {
      margin-top: 0;
    }
  }

  @media screen and (min-width: 1800px) {
    :host {
      width: 81.25rem !important;
    }
  }
</style>

<div class="bottle-image__wrapper" part="image">
  <div class="bottle-image"></div>
  <div class="bottle-text">
    <span class="bottle-recipient-name"></span>
    <span class="bottle-sender-name"></span>
  </div>
</div>
`;

type PersonalisationData = {
  // These keys should match those that are set on all personalisation-input elements
  recipientName:string;
  senderName:string;
}

type PersonalisationColor = {
  fontColor: string;
  labelColor: string;
};

export class PersonalisationImage extends HTMLElement {

  // Properties
  private readonly root: HTMLDivElement|null;
  private bottleImages:HTMLElement[];
  private readonly image: HTMLImageElement;
  private readonly bottleRecipientName: HTMLElement;
  private readonly bottleSenderName: HTMLElement;
  private readonly bottleTextContainer: HTMLElement;
  private readonly bottleImage = this.getAttribute('bottle-image');
  private readonly boxImage = this.getAttribute('box-image');
  // Constructor
  constructor() {
    super();
    // Attach shadow root
    const shadowRoot = this.attachShadow({ mode: 'open' });
    shadowRoot.appendChild(template.content.cloneNode(true));

    // Query things
    this.root = shadowRoot.querySelector('.bottle-image__wrapper')!;
    this.image = shadowRoot.querySelector('.bottle-image')!;
    this.bottleRecipientName = shadowRoot.querySelector('.bottle-recipient-name')!;
    this.bottleSenderName = shadowRoot.querySelector('.bottle-sender-name')!;
    this.bottleTextContainer = shadowRoot.querySelector('.bottle-text')!;
    const elemClass = this.dataset.class;
    if (elemClass) this.image.classList.add(elemClass);
  }

  public setImage(imageType:string) {
    let imageSrc = imageType == 'Bottle' ? this.bottleImage : this.boxImage;

    this.image.innerHTML =  `<picture><img class="c-cart-drawer__promo-product-image" src="${imageSrc || ''}"></picture>`
    this.root?.setAttribute('data-image-active',imageType);
  }

  public setLabel(fontType:string, personalisationData:PersonalisationData, personalisationColor:PersonalisationColor, userHasTyped: boolean) {

    const {
      recipientName = '',
      senderName = ''
    } = personalisationData

    this.root?.setAttribute('data-font-type',fontType);

    let fontColorName = personalisationColor.fontColor.split(":")
    let labelColorName = personalisationColor.labelColor.split(":")

    this.bottleTextContainer.style.color = fontColorName[1];
    this.bottleTextContainer.style.background = labelColorName[1];

    if (recipientName) {
      this.bottleRecipientName.innerText = recipientName;
    } else {
      this.bottleRecipientName.innerText = '';
    }

    if (senderName) {
      this.bottleSenderName.innerText = senderName;
    } else {
      this.bottleSenderName.innerText =  '';
    }
  }
  
  public adjustFontSize(element: HTMLElement, maxLines: number = 1) {
    if (!element) return;
    element.style.fontSize = ''; 
    let style = window.getComputedStyle(element, null).getPropertyValue('font-size');
    let currentSize = parseFloat(style);

    if(maxLines === 1) {
        while(element.scrollWidth > element.offsetWidth && currentSize > 3) {
            currentSize -= 0.1;
            element.style.fontSize = currentSize + "px";
        }
    } 
    else {
        while(element.scrollHeight > element.offsetHeight * maxLines && currentSize > 3) {
            currentSize -= 0.1;
            element.style.fontSize = currentSize + "px";
        }
    }
  }

  clearName() {
    this.bottleRecipientName.innerText = '';
    this.bottleSenderName.innerText = '';
  }

}

if (!customElements.get('christmas-personalisation-image')) {
  customElements.define('christmas-personalisation-image', PersonalisationImage);
}